import { emptyFusionHubApi } from "src/common/service/fusionHub/emptyFusionHubApi";
import type { FusionhubIntegration } from "src/common/service/fusionHub/types";

const dummyApi = emptyFusionHubApi.injectEndpoints({
	endpoints: (builder) => ({
		// One GET /integrations/:id per Dummy: only that route carries the `values`
		// that say which source a Dummy is shown as.
		getDummyIntegrations: builder.query<
			FusionhubIntegration[],
			{ integrationIds: number[] }
		>({
			async queryFn({ integrationIds }, _api, _extraOptions, baseQuery) {
				const results = await Promise.all(
					integrationIds.map((integrationId) =>
						baseQuery(`/integrations/${integrationId}`),
					),
				);
				// WHY skip failures: a Dummy that can't be fetched just keeps its own look.
				return {
					data: results.flatMap((result) =>
						result.error ? [] : [result.data as FusionhubIntegration],
					),
				};
			},
			// WHY an hour: what a Dummy is shown as is fixed when it is created.
			keepUnusedDataFor: 3600,
		}),
	}),
	overrideExisting: "throw",
});

export const { useGetDummyIntegrationsQuery } = dummyApi;
